import { defineComponent as g, computed as h, ref as y, resolveComponent as f, createElementBlock as b, openBlock as _, normalizeClass as r, normalizeStyle as u, createElementVNode as s, createCommentVNode as p, withKeys as E, withModifiers as v, createVNode as $, renderSlot as m } from "vue";
import { a as C, E as D } from "../const-CZJ2cQu8.js";
import { D as N } from "../DIcon-DL2CGcbN.js";
import "../clone-CVUr0Shx.js";
import { u as R } from "../useModel-8eDFJuHe.js";
import "../cloneDeep-BYiA6ooS.js";
import { n as S } from "../index.browser-CWCjzKuA.js";
import { _ as V } from "../_plugin-vue_export-helper-CHgC5LLL.js";
import '../assets/DCheckbox-Dt4Hmtog.css';var M = /* @__PURE__ */ ((e) => (e.LARGE = "large", e.SMALL = "small", e))(M || {}), d = /* @__PURE__ */ ((e) => (e.GREEN_223 = "green-223", e.EMERALD_312 = "emerald-312", e.ORANGE_198 = "orange-198", e))(d || {}), k = /* @__PURE__ */ ((e) => (e.CHECK = "check/check", e.MINUS = "check/minus", e))(k || {});
const B = g({
  compatConfig: {
    MODE: 3
  },
  components: {
    DIcon: N
  },
  props: {
    id: { type: String, default: () => S() },
    color: { type: String, default: () => d.GREEN_223 },
    block: { type: Boolean },
    dark: { type: Boolean },
    modelValue: { type: Boolean },
    icon: { type: String, default: () => k.CHECK },
    disabled: Boolean,
    error: Boolean,
    tabindex: { type: Number, default: 0 },
    name: { type: String, default: "" }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: o }) {
    const a = R(e, "modelValue", o), c = {
      default: {
        "--outline-color_error": "var(--d-color-red-241)",
        "--color_disabled": "var(--d-color-grey-284)",
        "--bg_error": "var(--d-color-red-241)"
      },
      lightDefault: {
        "--outline-color_disabled": "var(--d-color-grey-166)",
        "--bg_disabled": "var(--d-color-grey-114)",
        "--outline-color_iddle": "var(--d-color-grey-166)",
        "--bg_iddle": "var(--d-color-white-101)",
        "--outline-color_hover": "var(--d-color-grey-1514)",
        "--bg_hover": "var(--d-color-white-101)",
        "--color_iddle": "var(--d-color-grey-1514)"
      },
      darkDefault: {
        "--outline-color_disabled": "var(--d-color-grey-114)",
        "--bg_disabled": "var(--d-color-grey-166)",
        "--outline-color_iddle": "var(--d-color-grey-517)",
        "--bg_iddle": "var(--d-color-grey-868)",
        "--outline-color_hover": "var(--d-color-grey-166)",
        "--bg_hover": "var(--d-color-grey-868)",
        "--color_iddle": "var(--d-color-white-101)"
      }
    }, i = {
      [d.GREEN_223]: {
        "--outline-color_active": "var(--d-color-green-223)",
        "--bg_active": "var(--d-color-green-223)",
        "--outline-color_active_hover": "var(--d-color-green-333)",
        "--bg_active_hover": "var(--d-color-green-333)"
      },
      [d.EMERALD_312]: {
        "--outline-color_active": "var(--d-color-emerald-312)",
        "--bg_active": "var(--d-color-emerald-312)",
        "--outline-color_active_hover": "var(--d-color-emerald-439)",
        "--bg_active_hover": "var(--d-color-emerald-439)"
      },
      [d.ORANGE_198]: {
        "--outline-color_active": "var(--d-color-orange-198)",
        "--bg_active": "var(--d-color-orange-198)",
        "--outline-color_active_hover": "var(--d-color-orange-23)",
        "--bg_active_hover": "var(--d-color-orange-23)"
      }
    }, t = h(() => ({
      display: e.block ? "block" : "inline-block",
      ...c.default,
      ...e.dark ? c.darkDefault : c.lightDefault,
      ...i[e.color]
    })), n = () => {
      e.disabled || (a.value = !a.value);
    }, l = y(!1);
    return {
      style: t,
      localValue: a,
      EIconSize: D,
      EIconColor: C,
      EColor: d,
      onToggle: n,
      isFocused: l
    };
  }
}), G = {
  "d-checkbox": "_d-checkbox_m4fn2_1",
  "d-checkbox__controller": "_d-checkbox__controller_m4fn2_10",
  "d-checkbox__label": "_d-checkbox__label_m4fn2_21",
  "d-checkbox__icon": "_d-checkbox__icon_m4fn2_26",
  "d-checkbox_focused": "_d-checkbox_focused_m4fn2_34",
  "d-checkbox_active": "_d-checkbox_active_m4fn2_38",
  "d-checkbox_error": "_d-checkbox_error_m4fn2_46",
  "d-checkbox_disabled": "_d-checkbox_disabled_m4fn2_55",
  "d-checkbox__messages": "_d-checkbox__messages_m4fn2_60",
  "d-checkbox__box": "_d-checkbox__box_m4fn2_66",
  "d-checkbox__input": "_d-checkbox__input_m4fn2_81"
}, I = ["disabled", "tabindex", "for"], A = ["id", "name", "checked", "disabled"];
function w(e, o, a, c, i, t) {
  const n = f("DIcon");
  return _(), b("div", {
    style: u(e.style),
    class: r({
      [e.$style["d-checkbox"]]: !0,
      [e.$style["d-checkbox_dark"]]: e.dark,
      [e.$style["d-checkbox_error"]]: e.error,
      [e.$style["d-checkbox_active"]]: e.localValue,
      [e.$style["d-checkbox_focused"]]: e.isFocused,
      [e.$style["d-checkbox_disabled"]]: e.disabled,
      [e.$style["d-checkbox_color-green"]]: e.color === e.EColor.GREEN_223,
      [e.$style["d-checkbox_color-emerald"]]: e.color === e.EColor.EMERALD_312,
      [e.$style["d-checkbox_color-orange"]]: e.color === e.EColor.ORANGE_198
    })
  }, [
    s("label", {
      class: r({
        [e.$style["d-checkbox__controller"]]: !0
      }),
      disabled: e.disabled,
      tabindex: e.tabindex,
      role: "checkbox",
      for: e.id,
      onClick: o[1] || (o[1] = (...l) => e.onToggle && e.onToggle(...l)),
      onKeydown: o[2] || (o[2] = E(v((...l) => e.onToggle && e.onToggle(...l), ["prevent"]), ["space"])),
      onFocus: o[3] || (o[3] = (l) => e.isFocused = !0),
      onBlur: o[4] || (o[4] = (l) => e.isFocused = !1)
    }, [
      s("div", {
        class: r(e.$style["d-checkbox__box"])
      }, [
        $(n, {
          name: e.icon,
          size: e.EIconSize.S_16,
          color: !e.dark && e.disabled ? e.EIconColor.GREY_166 : e.EIconColor.WHITE_101,
          class: r({
            [e.$style["d-checkbox__icon"]]: !0
          }),
          style: u({
            opacity: e.localValue ? "1" : "0",
            transform: e.localValue ? "scale(1)" : "scale(.8)"
          }),
          bold: "",
          block: ""
        }, null, 8, ["name", "size", "color", "class", "style"])
      ], 2),
      s("input", {
        id: e.id,
        name: e.name,
        checked: e.localValue,
        type: "checkbox",
        disabled: e.disabled,
        class: r(e.$style["d-checkbox__input"]),
        tabindex: "-1",
        onClick: o[0] || (o[0] = v(() => {
        }, ["stop"]))
      }, null, 10, A),
      s("div", {
        class: r(e.$style["d-checkbox__label"])
      }, [
        m(e.$slots, "default")
      ], 2)
    ], 42, I),
    e.$slots.messages && !e.disabled ? (_(), b("div", {
      key: 0,
      class: r(e.$style["d-checkbox__messages"])
    }, [
      m(e.$slots, "messages")
    ], 2)) : p("", !0)
  ], 6);
}
const z = {
  $style: G
}, Y = /* @__PURE__ */ V(B, [["render", w], ["__cssModules", z]]);
export {
  Y as DCheckbox,
  d as EColor,
  k as EIcon,
  M as ESize
};
